window.$ = window.jQuery = require('jquery');
require('../Contrib/jQueryUi/jquery-ui');
require('superfish');
window.Swiper = require('swiper/js/swiper.min');


window.slidebars = require('../Contrib/slidebars/slidebars');

window.Cookies = require('js-cookie');
